<template>
  <div>
      <h1>VOCÊ SERÁ REDIRECIONADO...</h1>
  </div>
</template>

<script>
import { baseApiUrl } from '@/config/global'
export default {
    name: 'dashboard',
    // components: { CardSeplag},    
    data: function(){
        return{
           
        }
    },  
    created() {
        let dadosMTPrev = {
            "Matricula": this.$store.getters.getMatricula,
            "Cpf": this.$store.getters.getUser.contaAcesso.pessoa.numrCpf
        }
        this.$http.post(`${baseApiUrl}/mtprev/linkacesso`,JSON.stringify(dadosMTPrev)).then(res => {
            window.location.href = res.data
        })
    },

}
</script>

<style>

</style>